// @flow

import React from "react";

import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";
import * as formatters from "../../utils/formatters";

import {
  PURPOSE_KIND,
  FEDERAL_STATE,
  CORONA_TOTAL_REVENUE,
  CORONA_PERSONNEL_COSTS,
  CORONA_LIQUIDITY_NEED
} from "./formFields";

import { mapPurposeKind, getKind } from "./mappers";
import { type InvestmentProps } from "../../types/details";

const InvestmentCoronaEstablisher = ({
  kind,
  initialValues,
  handleSubmit,
  isLocked
}: InvestmentProps) => {
  return (
    <EditableForm initialValues={initialValues} onSubmit={handleSubmit} isLocked={isLocked}>
      <FormRow separator>
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND,
            caption: () => "Investitionsvorhaben"
          }}
          displayValue={value => {
            const purposeKind = getKind(value, kind);
            return purposeKind && mapPurposeKind(purposeKind.kind);
          }}
        />
        <EditableField
          fieldControlProps={{
            name: PURPOSE_KIND,
            caption: () => "Kreditbedarf"
          }}
          displayValue={value => {
            const purposeKind = getKind(value, kind);
            return purposeKind && formatters.formatCurrency(purposeKind.value);
          }}
        />
        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort liegt in..."
          }}
        />
      </FormRow>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: CORONA_TOTAL_REVENUE,
            caption: () => "Jahresumsatz 2019"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: CORONA_PERSONNEL_COSTS,
            caption: () => "Lohnkosten 2019"
          }}
          displayValue={formatters.formatCurrency}
        />
        <EditableField
          fieldControlProps={{
            name: CORONA_LIQUIDITY_NEED,
            caption: () => "Liquiditätsbedarf der nächsten 18 Monate"
          }}
          displayValue={formatters.formatCurrency}
        />
      </FormRow>
    </EditableForm>
  );
};

export default InvestmentCoronaEstablisher;
